import React, { FunctionComponent } from 'react';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TableChart from '@mui/icons-material/TableChart';
import { useSelector } from 'react-redux';
import { getTopLevelUserGroup } from 'application/redux/selectors';
import { getIsLumenRole } from 'helpers/roles';
import UnderwriterAlertsInfo from './UnderwriterAlertsInfo';
import MarketIntelNotes from './MarketIntelNotes';
import PdfNavItem from './PdfNavItem';

const PPUWGuidelinesInfo: FunctionComponent = () => {
    const group = useSelector(getTopLevelUserGroup);
    const isAdmin = getIsLumenRole(group);

    return (
        <>
            {isAdmin && <UnderwriterAlertsInfo />}
            <MarketIntelNotes />
            <PdfNavItem
                fileName="Lumen - UW Guidelines 012226.pdf"
                navItemTitle="UW Guidelines"
                icon={<AssignmentIcon />}
            />
            <PdfNavItem
                fileName="Lumen - UW Guidelines 012226.pdf"
                navItemTitle="Aggregation Guidelines"
                initialPageNumber={8}
                icon={<AssignmentIcon />}
            />
            <PdfNavItem fileName="Lumen - UW Rates 012326.pdf" navItemTitle="UW Rate Table" icon={<TableChart />} />
            <PdfNavItem
                fileName="Lumen - UW GL Guidelines 011325.pdf"
                navItemTitle="UW GL Guidelines"
                icon={<AssignmentIcon />}
            />
            <PdfNavItem
                fileName="Lumen - UW GL Scorecard 111124.pdf"
                navItemTitle="UW GL Scorecard"
                icon={<TableChart />}
            />
        </>
    );
};

export default PPUWGuidelinesInfo;
